import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
body {
  background: ${({ theme }) => theme.colors.bodyBackground};
  color: ${({ theme }) => theme.colors.bodyTextColor}
}
.btn{
  color: ${({ theme }) => theme.colors.btnColor} 
}
.dark-nav-link{
  color: ${({ theme }) => theme.colors.darkNavLink} 
}

.section-heading h2 span {
  color: ${({ theme }) => theme.colors.sectionHeadingSpan} 
}
.light-nav-link::after {
  background-color: ${({ theme }) => theme.colors.navLinkUnderline}
}
.dark-nav-link::after {
  background-color: ${({ theme }) => theme.colors.darkNavLinkAfter}
}
.section-about {
  background-color: ${({ theme }) => theme.colors.aboutSectionBackground}
}
header.page-heading{
background-color: ${({ theme }) => theme.colors.pageHeadingBackground};
h2{
color: ${({ theme }) => theme.colors.pageHeadingColor};
}
} 
.dark-nav-link.active {
  color: ${({ theme }) => theme.colors.darkNavLinkActive};
}
.footer {
  background-color: ${({ theme }) => theme.colors.footerBackground};
}
li a{
  color: ${({ theme }) => theme.colors.contactLinkColor};
}
.projects-btn{
  color: ${({ theme }) => theme.colors.projectsButtonColor};
  background-color: ${({ theme }) => theme.colors.projectsButtonBackground};
  &:hover, &:focus{
     background-color: ${({ theme }) => theme.colors.projectsButtonColor};
     color: ${({ theme }) => theme.colors.projectsButtonBackground};
  }
}
.nav-toggle{
  color: ${({ theme }) => theme.colors.mobileNavToggleColor};
  background-color: ${({ theme }) => theme.colors.mobileNavToggleBackground};
}
.sidebar-close {
  color: ${({ theme }) => theme.colors.sidebarCloseColor};
}
.light-nav-link.active{
  color: ${({ theme }) => theme.colors.lightNavLinkActive};
  
}
.show-sidebar{
  background-color: ${({ theme }) => theme.colors.sidebarOpaque};
}
.sidebar-container{
background-color: ${({ theme }) => theme.colors.transparent};
}
.download-btn-container a button, .hero-btn{
  &:hover{
  color: ${({ theme }) => theme.colors.downloadResumeButtonColor};
  }
}
.download-btn-container a:focus{
    color: ${({ theme }) => theme.colors.downloadResumeButtonBackground};
}

.nav-toggle{
  &:hover, &:focus{
background-color: ${({ theme }) => theme.colors.mobileNavToggleHoverBackground};
  }
}
.menu{
  --c: ${({ theme }) => theme.colors.mobileNavToggleBackground};
 &:hover, &:focus {
      --c: ${({ theme }) => theme.colors.mobileNavToggleHoverBackground};
    }
  }
.social-icon:hover {
  color: ${({ theme }) => theme.colors.socialIconHoverColor};
}
`;

export default GlobalStyles;
